import Routable from '../../mixins/routable'

export const Tile = {
  name: 'tile',

  mixins: [Routable],

  props: {
    column: { type: Boolean },
  },

  computed: {
    classes () {
      return {
        'tile layout child-flex': true,
        'column': this.column,
      }
    }
  },

  render(h) {
    const { tag, data } = this.generateRouteLink()
    return h(tag, data, [this.$slots.default])
  }
}

import Contextualable from '../../mixins/contextualable'

export const TileContent = {
  name: 'tile-content',
  
  mixins: [Contextualable],

  props: {
    block: { type: Boolean },
  },

  computed: {
    classes () {
      return {
        ...this.$contextualClasses,
        'tile__content': true,
        'tile__content--block': this.block,
      }
    }
  },

  render(h) {
    return h('n-flex', {class: this.classes, attrs: this.$attrs}, [this.$slots.default])
  }
}
